import Swiper, {renderOverlayLinkComponent} from './swiper';
import BannerSwiper from './banner-swiper';

/** @deprecated */
export {BannerSwiper, renderOverlayLinkComponent};
export default Swiper;
